import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './shared/contexts/AuthContext';
import { isConsole } from './lib/domain';

// Audience site
import AudienceLayout from './audience/AudienceLayout';
import HomePage from './audience/pages/HomePage';
import EventPage from './audience/pages/EventPage';
import AudienceLoginPage from './audience/pages/LoginPage';

// Performer console
import ConsoleLayout from './console/ConsoleLayout';
import EventsPage from './console/pages/EventsPage';
import CamerasPage from './console/pages/CamerasPage';
import PerformerDashboard from './console/pages/PerformerDashboard';
import ConsoleLoginPage from './console/pages/LoginPage';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center h-screen text-lg text-neutral-400">Loading...</div>;
  if (!user) return <Navigate to="/login" />;
  return children;
}

function AudienceApp() {
  const { user, login, logout } = useAuth();
  return (
    <Routes>
      <Route element={<AudienceLayout user={user} onLogout={logout} />}>
        <Route index element={<HomePage />} />
        <Route path="/event/:id" element={<EventPage />} />
        <Route path="/login" element={user ? <Navigate to="/" /> : <AudienceLoginPage onLogin={login} />} />
      </Route>
    </Routes>
  );
}

function ConsoleApp() {
  const { user, login, logout } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" /> : <ConsoleLoginPage onLogin={login} />} />
      <Route
        element={
          <ProtectedRoute>
            <ConsoleLayout user={user} onLogout={logout} />
          </ProtectedRoute>
        }
      >
        <Route index element={<EventsPage />} />
        <Route path="/cameras" element={<CamerasPage />} />
        <Route path="/events/:id/dashboard" element={<PerformerDashboard />} />
      </Route>
    </Routes>
  );
}

function App() {
  const console = isConsole();
  return (
    <AuthProvider>
      <BrowserRouter>
        {console ? <ConsoleApp /> : <AudienceApp />}
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
